import { useCallback, useState } from "react";
import { Btn, H3, P } from "../../../AbstractElements";
import { Configuration, PreviewsSettings, TryItRealTime } from "../../../Constant";
import { TabHeaderProps } from "../../../Type/CustomizerType";
import ConfigurationClass from "./ConfigurationClass";

const TabHeaders = ({ callbackNav }: TabHeaderProps) => {
  const [modal, setModal] = useState(false);
  const toggle = useCallback(() => {
    setModal(!modal);
  }, [modal]);

  return (
    <div className="customizer-header">
      <i className="icofont-close icon-close" onClick={() => callbackNav("", false)}></i>
      <H3>{PreviewsSettings}</H3>
      <P className="mb-0">{TryItRealTime}<i className="fa fa-thumbs-o-up txt-primary ms-1"></i></P>
      <Btn color="primary" className="plus-popup mt-2" onClick={toggle}>{Configuration}</Btn>
      <ConfigurationClass modal={modal} toggle={toggle} />
    </div>
  );
};

export default TabHeaders;
